export const errors = {
  'Page not available': 'Página no disponible',
  'Something went wrong, please try again later.':
    'Algo salió mal, por favor inténtelo de nuevo más tarde.',
  Home: 'Inicio',
};
